import React from 'lib/react';
import {
  EVGrid, EVTypography, EVCheckbox,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import { useSelector, useDispatch } from 'lib/redux';
import { PRODUCT_FAMILY_ID_EVCORE } from 'constants/AppConstants';
import { updateInputFieldValue } from 'features/orderPreferences/OrderPreferences.actions';
import { getPropertyValues } from 'features/orderPreferences/OrderPreferences.utils';
import ProductAddonsStyles from './ProductAddonsStyles';
import ProductAddonsReportsFormat from './components/ProductAddonsReportsFormat.component';
import PageHeading from '../PageHeading.component';

function ProductAddons() {
  const { t } = useTranslation();
  const classes = ProductAddonsStyles();
  const dispatch = useDispatch();

  const orderPreferences = useSelector(({ userData }) => userData.orderPreferences);
  const { isAdmin } = orderPreferences;
  const productFamilyId = useSelector(({ userData }) => userData?.initParameters?.productFamilyId);
  const hideAdditionalReportFormats = productFamilyId === PRODUCT_FAMILY_ID_EVCORE;

  const inputFieldValues = useSelector(({ orderPreference }) => orderPreference.inputFieldValues);

  const handleChange = (propertyName, key) => ({ target: { checked } }) => dispatch(updateInputFieldValue(propertyName, key, checked));

  return (
    <>
      <PageHeading
        title={t('order_preferences__product_addons_title')}
        description={t('order_preferences__product_addons_desc')}
      />
      <EVGrid className={classes.productAddonsContentContainer}>
        <EVTypography className={classes.productsAndDeliveryTitle}>{t('order_preferences__product_addons_subTitle')}</EVTypography>
        <EVGrid className={classes.addonsContentBox}>
          <EVGrid className={classes.addonsElementsCB}>
            <EVCheckbox
              id="reportOptionsDeliverablePropertyOwnerValueCB"
              checked={getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsDeliverablePropertyOwner').value}
              disabled={!orderPreferences.reportOptionsDeliverablePropertyOwner.canEdit}
              color="primary"
              className={classes.checkChanges}
              onChange={handleChange('reportOptionsDeliverablePropertyOwner', 'value')}
            />
            <label
              className={classes.propertyOwnerText}
              htmlFor="reportOptionsDeliverablePropertyOwnerValueCB"
            >
              {t('order_preferences__property_owner_report')}
            </label>
          </EVGrid>
          <EVTypography className={classes.propertyOwnerSubText}>{t('order_preferences__property_owner_report_subText')}</EVTypography>
          {isAdmin && (
          <EVGrid className={classes.addonsElementsCB}>
            <EVCheckbox
              id="reportOptionsDeliverablePropertyOwnerAllowSubAccountsCB"
              checked={getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsDeliverablePropertyOwner').allowSubAccounts}
              disabled={!orderPreferences.reportOptionsDeliverablePropertyOwner.canEdit}
              onChange={handleChange('reportOptionsDeliverablePropertyOwner', 'allowSubAccounts')}
              color="primary"
              className={classes.checkChanges}
            />
            <label
              className={classes.propertyOwnerCBText}
              htmlFor="reportOptionsDeliverablePropertyOwnerAllowSubAccountsCB"
            >
              {t('order_preferences__property_owner_report_CB')}
            </label>
          </EVGrid>
          )}
        </EVGrid>
      </EVGrid>
      {!hideAdditionalReportFormats && (
      <EVGrid className={classes.productAddonsContentContainer}>
        <EVTypography className={classes.productsAndDeliveryTitle}>{t('order_preferences__product_addons_additional_report')}</EVTypography>
        <EVGrid className={classes.addonsContentBox}>
          <EVTypography className={classes.propertyOwnerSubText}>{t('order_preferences__product_addons_additional_report_note')}</EVTypography>
          <ProductAddonsReportsFormat
            subKey="value"
            handleChange={handleChange}
          />
        </EVGrid>
        {isAdmin && (
          <EVGrid className={classes.addonsContentBox}>
            <EVTypography className={classes.propertyOwnerCBText}>{t('order_preferences__additional_report_CB')}</EVTypography>
            <ProductAddonsReportsFormat
              subKey="allowSubAccounts"
              handleChange={handleChange}
            />
          </EVGrid>
        )}
      </EVGrid>
      )}
    </>
  );
}
export default ProductAddons;
